import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import EventPayrollAutoDeduction from "../AutoDeduction/EventPayrollAutoDeduction";
import EventPayrollPaymentSummary from "../EventPayrollPaymentSummary";

import "./_EventPayrollHeader.scss";

const EventPayrollHeader = ({
  labels,
  summaryLabels,
  stats,
  isMonthly,
  lateCheckInDeduction,
  autoCheckout,
  canEdit,
  autoDeductionDisabled,
  onLateCheckInDeductionChange,
  onAutoCheckoutChange,
  children,
}) => (
  <Box className="event-payroll__header">
    <EventPayrollAutoDeduction
      labels={labels}
      isMonthly={isMonthly}
      lateCheckInDeduction={lateCheckInDeduction}
      autoCheckout={autoCheckout}
      canEdit={canEdit}
      disabled={autoDeductionDisabled}
      onLateCheckInDeductionChange={onLateCheckInDeductionChange}
      onAutoCheckoutChange={onAutoCheckoutChange}
    />
    {children}
    <EventPayrollPaymentSummary
      paidCount={stats.paidCount}
      pendingCount={stats.pendingCount}
      labels={summaryLabels}
    />
  </Box>
);

EventPayrollHeader.propTypes = {
  labels: PropTypes.object.isRequired,
  summaryLabels: PropTypes.object.isRequired,
  stats: PropTypes.shape({
    paidCount: PropTypes.number.isRequired,
    pendingCount: PropTypes.number.isRequired,
  }).isRequired,
  isMonthly: PropTypes.bool.isRequired,
  lateCheckInDeduction: PropTypes.bool.isRequired,
  autoCheckout: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
  autoDeductionDisabled: PropTypes.bool,
  onLateCheckInDeductionChange: PropTypes.func.isRequired,
  onAutoCheckoutChange: PropTypes.func.isRequired,
  children: PropTypes.node,
};

EventPayrollHeader.defaultProps = {
  canEdit: true,
  autoDeductionDisabled: false,
  children: null,
};

export default EventPayrollHeader;
